module.exports = __webpack_public_path__ + "img/1.844f25bd.png";